import React, {PropTypes} from 'react';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';

import Label from './Label';

const ITEM_BORDER = 10;

const Item = SortableElement(props => {
  const itemWidth = `${props.labelSize.width + ITEM_BORDER}px`;
  const itemHeight = `${props.labelSize.height + ITEM_BORDER}px`;

  let gridItemClass = 'gridItem';
  if(Object.keys(props.data).length !== 0) {
    gridItemClass += ' filled';
  }

  return (
    <div className={props.className} style={{height: itemHeight, maxHeight: itemHeight, width: itemWidth, maxWidth: itemWidth}}>
      <div className={gridItemClass}>
        <Label canHover={props.canHover} data={props.data} index={props.labelIndex} onSelected={props.onSelected}/>
      </div>
    </div>
  );
});

const SortableList = SortableContainer(({
  className,
  isSorting,
  items,
  itemClass,
  labelSize,
  onSelected
}) => {
  const gridWidth = (labelSize.width + ITEM_BORDER) * 2;
  return (
    <div className={className} style={{width: `${gridWidth}px`}}>
      {items.map((label, index) => (
        <Item
          key={`item-${index}`}
          className={itemClass}
          index={index}
          labelIndex={index}
          data={label}
          onSelected={onSelected}
          labelSize={labelSize}
          canHover={!isSorting}
        />
      ))}
    </div>
  );
});

SortableList.propTypes = {
	className: PropTypes.string.isRequired,
  isSorting: PropTypes.bool.isRequired,
	items: PropTypes.array.isRequired,
	itemClass: PropTypes.string.isRequired,
  labelSize: PropTypes.object.isRequired,
  onSelected: PropTypes.func.isRequired
};

export default SortableList;


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/SortableList.js
 **/